/* eslint-disable eqeqeq */
import VersionNav from "./VersionNav";
import useFetch from "../../../../components/useFetch";
import ErrorScreen from "../../../../components/error/ErrorScreen";
import "split-pane-react/esm/themes/default.css";
import Loader from "../../../../components/Loader";
export default function VersionDetail2({ id, selectdata, preview, datasetId, selectedRowInfo, projectId, dataOverride, scatterFilterPlacement }) {
;
  const url = selectdata
    ? `datasets/data_hub/${id}/main`
    : dataOverride
      ? null
      : `dataset_versions/${id}/plots?page_number=1`;
  const { data: fetchedData, loading, error } = useFetch(url, "get");
  const data = dataOverride || fetchedData;


  if (!dataOverride && loading) return <Loader />;


  if (error || data?.info?.dataset_name == undefined) {
    return <ErrorScreen message={"No version Detail Found"} />;
  }


  return (
    <div className="" style={{ width: "100%", height: "92%" }}>
      {data && (
        <>
          <VersionNav
            data={data}
            id={id}
            taskType={data?.task_type}
            preview={preview}
            datasetId={datasetId}
            disableFetchMore={!!dataOverride}
            scatterFilterPlacement={scatterFilterPlacement}
          />

        </>
      )}
    </div>
  );
}
